<template>
    <component
        :is="iconComponent"
        v-if="iconComponent"
        :class="classes"
        class="yp-icon fill-current flex-shrink-0"
    />
</template>

<script>
import icons from '@/icons/YpIcons';
import { computed } from 'vue';
import { stringToArray } from '@/utils/string-to-array';

export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        size: {
            type: String,
            default: 'md',
        },
        tailwind: {
            type: [String, Array],
            default: () => [],
        },
    },
    setup(props) {
        const iconComponent = computed(() => {
            if (!(props.name in icons)) {
                return null;
            }

            return icons[props.name];
        });

        const classes = computed(() => {
            const classList = [];
            const sizes = {
                xxs: 'h-4 w-4',
                xs: 'h-5 w-5',
                sm: 'h-6 w-6',
                md: 'h-8 w-8',
                lg: 'h-10 w-10',
                xl: 'h-12 w-12',
            };

            classList.push(sizes[props.size] || sizes.md);

            classList.push(...stringToArray(props.tailwind));

            return classList;
        });

        return {
            iconComponent,
            classes,
        };
    },
};
</script>
